import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const styles = theme => ({
  stepper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    //background: theme.palette.background.default,
    backgroundColor: 'rgba(255,255,255,0)!important',
    padding: 8,
  },
  /* Styles applied to the dots container if `variant="dots"`. */
  dots: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  dotContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '10px',
      height: '30px',
      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      width: '20px',
      height: '40px',
      margin: '0 calc((100% - 480px) / 48)',
    },
  },
  /* Styles applied to each dot if `variant="dots"`. */
  dot: {
    backgroundColor: '#8b7f7e',
    borderRadius: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '10px',
      height: '10px',
      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      width: '20px',
      height: '20px',
      margin: '0 calc((100% - 480px) / 48)',
    },
  },
  hourContainer: {
    textAlign: 'center',
    paddingTop: '5px',
    height: '25px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7em',
      width: '10px',

      margin: '0 calc((100% - 240px) / 48)',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '0.9em',
      width: '20px',
      margin: '0 calc((100% - 480px) / 48)',
    },

  },
  /* Styles applied to a dot if `variant="dots"` and this is the active step. */
  dotActive: {
    backgroundColor: theme.palette.primary.main,
  },
  dotInactive:{
    //color:'#f3f3f3',
    color:'#dbdbdb',
  },
  activeButton:{
    padding:'0',
    display:'inline-flex',
    flex:'0 0  auto',
    height:'48px',
    width:'48px',
    textAlign:'center',
    verticalAlign:'middle',
    justifyContent:'center',
  },
  activeSpan: {
    justifyContent:'center',
    alignItems:'center',
    display:'flex',
  },
});


let isIE = /*@cc_on!@*/false || !!document.documentMode;

let initialPlayingState=isIE?false:true
//let initialPlayingState = false

class VideoControl extends React.Component {
  constructor(props) {
    super(props)

    this.pauseMovement = this.pauseMovement.bind(this);
    this.playMovement = this.playMovement.bind(this);
  }

  state = {
    playing:initialPlayingState,
  }

  pauseMovement(){
    this.setState((previousState,props)=>{
      return {
        playing:false
      }
    })
    this.props.setPlayingState(false)
  }

  playMovement(){
    this.setState((previousState,props)=>{
      return {
        playing:true
      }
    })
    this.props.setPlayingState(true)
  }

  render() {
    const { classes } = this.props;

    if (!this.props.dataReady) {
      return (
        <div className={classes.root}>
        {
          // <CircularProgress className={classes.progress} size={50} />
        }
        </div>
      )
    }

    const activeStep = this.props.activeStep;
    let totalSteps = this.props.data.length;
    let activeColor = this.props.activeColor
    //let inactiveColor = '#f3f3f3'
    let inactiveColor = '#dbdbdb'
    //if (this.props.currentMode === 'historical'){
    //  totalSteps=12;
    //}
    
    let hourCounter = 0

    let shortMonths = ["jan", "feb", "maa", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"]

    const  nextStep= (activeStep + 1) % parseInt(totalSteps)
    return (
      <div className={classes.root}>
        <Paper square elevation={0} className={classes.stepper} 
          //style={{ marginTop: (window.innerWidth > 1280 && this.props.currentMode === 'realtime' ? '220px' : 0) } /* to accomodate for the alarm clock if needed */}
        >
          <div className={classes.dots}>
            {[...new Array(totalSteps)].map((_, step) => {
              hourCounter++;
              return (<div key={step} className={classes.dotContainer}>
                {
                  //<div className={classes.dot} style={(step === activeStep ? { backgroundColor: activeColor } : (hourCounter>this.props.data.length?{backgroundColor:inactiveColor}:{}))} /> 
                }    
                <div className={classes.dot} style={(step === activeStep ? { backgroundColor: activeColor } : {backgroundColor:inactiveColor})} />
                <div className={classes.hourContainer + (hourCounter>this.props.data.length?(" "+ classes.dotInactive):'')}> 
                {
                  this.props.currentMode === 'realtime' ?
                  ((hourCounter - 1) % 6 === 0 ?
                    (((hourCounter - 1) < 10 ? ("0" + (hourCounter - 1)) : (hourCounter - 1)) + ':00') :
                    ' '
                  ) :
                  shortMonths[hourCounter - 1]
                }
                </div>
              </div>);
            })}
          </div>
        </Paper>
        {this.state.playing?
          <div className={classes.activeButton}>
            <span className={classes.activeSpan}><ArrowBackIcon /></span>
          </div>
          :
          <IconButton
            data-active_step= {activeStep === 0 ? (totalSteps - 1) : (activeStep - 1)}
            //onClick={this.props.setActiveStep}
            onClick={() => this.props.changeActiveStep(activeStep === 0 ? (totalSteps - 1) : (activeStep - 1))}
          >
            <ArrowBackIcon />
          </IconButton>
        }
        {this.state.playing?
          <IconButton onClick={this.pauseMovement}>
            <PauseIcon />
          </IconButton>:
          <div className={classes.activeButton}>
            <span className={classes.activeSpan}><PauseIcon /></span>
          </div>
        }
        {this.state.playing?
          <div className={classes.activeButton}>
            <span className={classes.activeSpan}><PlayArrowIcon /></span>
          </div>:
          <IconButton onClick={this.playMovement} >
            <PlayArrowIcon />
          </IconButton>
        }
        {this.state.playing?
          <div className={classes.activeButton}>
            <span className={classes.activeSpan}><ArrowForwardIcon /></span>
          </div>
          :
          <IconButton 
            //data-active_step= {(activeStep + 1) % parseInt(totalSteps)}
            data-active_step= {nextStep.toString()}
            //onClick={this.props.setActiveStep}
            onClick={() => this.props.changeActiveStep((activeStep + 1) % parseInt(totalSteps))}
          >  
            <ArrowForwardIcon />
          </IconButton>
        }
      </div>
    );

  }
}

VideoControl.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(VideoControl);